import { onDocumentScroll } from "../../js/utils";

function resetSearch(inputs: NodeListOf<HTMLInputElement>): void {
  inputs.forEach((el) => {
    el.value = "";
  });
}

// Fade elements in as they enter the viewport on scroll
// NOTE: This will actully modify the passed Set and remove
//       any elements which are faded in!
function fadeElementsWhenInView(inputs: Set<HTMLElement>) {
  inputs.forEach((el) => {
    const isInView = el.offsetTop + 50 <= window.scrollY + window.innerHeight;

    if (isInView) {
      el.classList.add("columns-component__inner--project-fade-in");
      inputs.delete(el);
    }
  });
}

export function projectsSearch(
  projectWrapper: Element,
  projects: NodeListOf<HTMLElement>
) {
  let projectsToFadeIn = new Set([...projects]);

  // Prepare elements to be faded in...
  setTimeout(() => {
    projectsToFadeIn.forEach((p) => {
      p.classList.add("columns-component__inner--project-ready-to-fade-in");
    });
  });

  // Fade elements in as they enter the viewport
  setTimeout(() => fadeElementsWhenInView(projectsToFadeIn), 150);

  const removeScrollListener = onDocumentScroll(() => {
    if (projectsToFadeIn.size === 0) {
      removeScrollListener();
    }
    fadeElementsWhenInView(projectsToFadeIn);
  });
  // This is for adding/removing a class to the wrapping element
  // for use to style the grid/list depending on if filter is enabled
  // or not.
  let filtered = false;
  function toggleGlobalFilterProps(bool: boolean, force?: boolean) {
    if ((force && bool) || (bool && !filtered)) {
      filtered = true;
      projectWrapper.classList.add(
        "projects-overview-component--filter-enabled"
      );
      projectWrapper.classList.remove(
        "projects-overview-component--filter-disabled"
      );
    }
    if ((force && !bool) || (!bool && filtered)) {
      filtered = false;
      projectWrapper.classList.remove(
        "projects-overview-component--filter-enabled"
      );
      projectWrapper.classList.add(
        "projects-overview-component--filter-disabled"
      );
    }

    setTimeout(() => {
      filtered && fadeElementsWhenInView(projectsToFadeIn);
    });
  }
  // Set it to disabled by default...
  toggleGlobalFilterProps(false, true);

  // SEARCH
  // IDEA(kristoffer): Maybe also search in tags?
  //                   Nah, not today!
  setTimeout(() => {
    const inputs: NodeListOf<HTMLInputElement> =
      projectWrapper.querySelectorAll(
        ".explainer_projects_search_wrapper .nf-field input"
      );
    inputs.forEach((el) => {
      el.addEventListener("keyup", (e) => {
        resetSelect();
        const value = (<HTMLInputElement>e.target).value;
        const regexp = new RegExp(value, "gi");
        if (value.length > 1) {
          toggleGlobalFilterProps(true);
          projects.forEach((project) => {
            const res = project.innerText.search(regexp);
            if (res < 0) {
              project.classList.add("columns-component__inner--hidden-project");
            } else {
              project.classList.remove(
                "columns-component__inner--hidden-project"
              );
            }
          });
        } else {
          toggleGlobalFilterProps(false);
          projects.forEach((project) => {
            project.classList.remove(
              "columns-component__inner--hidden-project"
            );
          });
        }
      });
    });

    // TAGS - NEW VERSION
    const select: HTMLSelectElement | null = projectWrapper.querySelector(
      ".columns-component__tags-select"
    );
    function resetSelect() {
      toggleGlobalFilterProps(false);
      if (select) {
        select.selectedIndex = 0;
      }
    }
    if (select) {
      select.addEventListener("change", (e) => {
        const t = e.target as HTMLSelectElement;
        const id = t.value;
        resetSearch(inputs);
        let enabledFilter = false;
        const isReset = id === "RESET";
        projects.forEach((project) => {
          const ids = new Set(project.getAttribute("data-tag-ids")?.split(","));
          if (isReset || (id && ids.has(id))) {
            enabledFilter = true;
            project.classList.remove(
              "columns-component__inner--hidden-project"
            );
          } else {
            project.classList.add("columns-component__inner--hidden-project");
          }
        });
        if (isReset) {
          toggleGlobalFilterProps(false, true);
          resetSelect();
        } else {
          toggleGlobalFilterProps(enabledFilter);
        }
      });
    }
  }, 2000);
}

export function initProjects() {
  const projectWrappers = document.querySelectorAll(
    ".projects-overview-component"
  );
  projectWrappers.forEach((projectWrapper) => {
    const projects: NodeListOf<HTMLElement> = projectWrapper.querySelectorAll(
      ".columns-component__inner--project"
    );
    projectsSearch(projectWrapper, projects);
  });
}
